import React, { useState, useEffect, useContext } from 'react';
import { LoginContext } from '../Login/LoginContext';
import axios from 'axios';
import Url from '../Url';
import './Sharecreate.css';

export default function Sharecreate() {
    const { loginResult } = useContext(LoginContext);
    const user_id = loginResult?.user_id;

    const [templates, setTemplates] = useState([]);
    const [loadingTemplates, setLoadingTemplates] = useState(true);
    const [errorTemplates, setErrorTemplates] = useState(null);

    // Get unique status_template options from templates
    const statusTemplateOptions = Array.from(new Set(templates.map(t => t.status_template))).filter(Boolean);

    const [newFormData, setNewFormData] = useState({ templtname: '', message: '', status_template: '' });
    const [editFormData, setEditFormData] = useState({
        selectedTemplateName: '',
        templtname: '',
        message: '',
        id: '',
        status_template: '',
    });

    const [showNewForm, setShowNewForm] = useState(false);
    const [showEditForm, setShowEditForm] = useState(false);
    const [showFilterPanel, setShowFilterPanel] = useState(false);

    const [selectedStatusTemplates, setSelectedStatusTemplates] = useState([]);

    const [popupMessage, setPopupMessage] = useState('');
    const [showPopup, setShowPopup] = useState(false);

    const showPopupMessage = (message) => {
        setPopupMessage(message);
        setShowPopup(true);
        setTimeout(() => setShowPopup(false), 3000);
    };

    const fetchTemplates = async () => {
        if (!user_id) return;
        setLoadingTemplates(true);
        try {
            const report_id = 13;
            const res = await axios.get(`${Url.Url}/get_report?data={"user_id":"${user_id}","report_id":"${report_id}"}`);
            if (Array.isArray(res.data) && res.data.length > 0 && Array.isArray(res.data)) {
                setTemplates(res.data);
            } else {
                setTemplates([]);
            }
        } catch (e) {
            setErrorTemplates('Failed to load templates. Please try again.');
            setTemplates([]);
        } finally {
            setLoadingTemplates(false);
        }
    };

    useEffect(() => {
        fetchTemplates();
    }, [user_id]);

    useEffect(() => {
        const handleKeyDown = (e) => {
            if (e.key === 'F2') {
                e.preventDefault();
                setShowNewForm(prev => !prev);
                setShowEditForm(false);
                setShowFilterPanel(false);
            }
            if (e.key === 'F3') {
                e.preventDefault();
                setShowEditForm(prev => !prev);
                setShowNewForm(false);
                setShowFilterPanel(false);
            }
            if (e.key === 'F5') {
                e.preventDefault();
                setShowFilterPanel(true);
                setShowNewForm(false);
                setShowEditForm(false);
            }
            if (e.key === 'Escape') {
                setShowNewForm(false);
                setShowEditForm(false);
                setShowFilterPanel(false);
            }
        };

        window.addEventListener('keydown', handleKeyDown);
        return () => window.removeEventListener('keydown', handleKeyDown);
    }, []);

    const handleNewChange = (e) => {
        const { name, value } = e.target;
        setNewFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleEditSelectChange = (e) => {
        const selectedName = e.target.value;
        const selectedTemplate = templates.find(t => t.templtname === selectedName);
        if (selectedTemplate) {
            setEditFormData({
                selectedTemplateName: selectedName,
                templtname: selectedTemplate.templtname,
                message: selectedTemplate.message,
                id: selectedTemplate.id || '',
                status_template: selectedTemplate.status_template || '',
            });
        }
    };

    const handleEditInputChange = (e) => {
        const { name, value } = e.target;
        setEditFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleNewSubmit = async (e) => {
        e.preventDefault();
        if (!user_id) return;

        const payload = {
            data: {
                templtname: newFormData.templtname,
                message: newFormData.message,
                status_template: newFormData.status_template,
                Under_id: user_id,
                postid: 4,
            }
        };

        try {
            const res = await axios.post(`${Url.Url}/post_data`, payload, {
                headers: { 'Content-Type': 'application/json' },
            });
            showPopupMessage(res.data?.message || 'Template created!');
            setNewFormData({ templtname: '', message: '', status_template: '' });
            setShowNewForm(false);
            fetchTemplates();
        } catch (err) {
            showPopupMessage('Error creating template');
        }
    };

    const handleEditSubmit = async (e) => {
        e.preventDefault();
        if (!user_id || !editFormData.id) return;

        const payload = {
            data: {
                templtname: editFormData.templtname,
                message: editFormData.message,
                status_template: editFormData.status_template,
                Under_id: user_id,
                postid: 5,
                id: editFormData.id,
            }
        };

        try {
            const res = await axios.post(`${Url.Url}/post_data`, payload, {
                headers: { 'Content-Type': 'application/json' },
            });
            showPopupMessage(res.data?.message || 'Template updated!');
            setShowEditForm(false);
            // ✅ Clear edit form
            setEditFormData({
                selectedTemplateName: '',
                templtname: '',
                message: '',
                id: '',
                status_template: '',
            });
            fetchTemplates();
        } catch (err) {
            showPopupMessage('Error updating template');
        }
    };

    // Handle checkbox change for status_template filter
    const handleStatusTemplateCheckbox = (e) => {
        const { value, checked } = e.target;
        setSelectedStatusTemplates(prev =>
            checked
                ? [...prev, value]
                : prev.filter(v => v !== value)
        );
    };

    // Filter templates based on selectedStatusTemplates
    const filteredTemplates = selectedStatusTemplates.length === 0
        ? templates
        : templates.filter(t => selectedStatusTemplates.includes(t.status_template));

    return (
        <div className="share-create-container">
            {loadingTemplates && <p className="message-info">Loading templates...</p>}
            {errorTemplates && <p className="error-message">{errorTemplates}</p>}
        

            <div className="template-grid">
                {filteredTemplates.map((template, i) => (
                    <div key={i} className="template-item">
                        <h3>{template.templtname}</h3>
                        <p className="template-message">{template.message}</p>
                    </div>
                ))}
            </div>

            {/* New Template Panel */}
            <div className={`off-canvas-panel ${showNewForm ? 'open' : ''}`}>
                <div className="off-canvas-header">
                    <h2>New Template</h2>
                    <button className="close-panel-button" onClick={() => setShowNewForm(false)}>&times;</button>
                </div>
                <form onSubmit={handleNewSubmit}>
                    <div className="form-group">
                        <input
                            type="text"
                            name="templtname"
                            placeholder="Template Name"
                            value={newFormData.templtname}
                            onChange={handleNewChange}
                            autoComplete="off"
                            required
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <textarea
                            name="message"
                            placeholder="Message"
                            value={newFormData.message}
                            onChange={handleNewChange}
                            rows={6}
                            autoComplete="off"
                            required
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <select
                            name="status_template"
                            value={newFormData.status_template}
                            onChange={handleNewChange}
                            required
                            className="form-control"
                        >
                            <option value="" disabled>Select Group</option>
                            {statusTemplateOptions.map((opt, i) => (
                                <option key={i} value={opt}>{opt}</option>
                            ))}
                        </select>
                    </div>
                    <button type="submit" className="submit-button">Create Template</button>
                </form>
            </div>

            {/* Edit Template Panel */}
            <div className={`off-canvas-panel ${showEditForm ? 'open' : ''}`}>
                <div className="off-canvas-header">
                    <h2>Edit Template</h2>
                    <button className="close-panel-button" onClick={() => setShowEditForm(false)}>&times;</button>
                </div>
                <form onSubmit={handleEditSubmit}>
                    <div className="form-group">
                        <label htmlFor="selectTemplate">Select Template</label>
                        <select
                            id="selectTemplate"
                            value={editFormData.selectedTemplateName}
                            onChange={handleEditSelectChange}
                            required
                            className="form-control"
                        >
                            <option value="" disabled>Select a template</option>
                            {templates.map((template, i) => (
                                <option key={i} value={template.templtname}>{template.templtname}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <input
                            type="text"
                            name="templtname"
                            placeholder="Edit Template Name"
                            value={editFormData.templtname}
                            onChange={handleEditInputChange}
                            autoComplete="off"
                            required
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <textarea
                            name="message"
                            placeholder="Edit Message"
                            value={editFormData.message}
                            onChange={handleEditInputChange}
                            rows={6}
                            autoComplete="off"
                            required
                            className="form-control"
                        />
                    </div>
                    <div className="form-group">
                        <select
                            name="status_template"
                            value={editFormData.status_template}
                            onChange={handleEditInputChange}
                            required
                            className="form-control"
                        >
                            <option value="" disabled>Select Group</option>
                            {statusTemplateOptions.map((opt, i) => (
                                <option key={i} value={opt}>{opt}</option>
                            ))}
                        </select>
                    </div>
                    <button type="submit" className="submit-button">Update Template</button>
                </form>
            </div>

            {/* Filter Panel (F5) */}
            <div className={`off-canvas-panel right-panel ${showFilterPanel ? 'open' : ''}`}>
                <div className="off-canvas-header">
                    <h2>Filter by Group</h2>
                    <button className="close-panel-button" onClick={() => setShowFilterPanel(false)}>&times;</button>
                </div>
                <div className="form-group filter-checkbox-list">
                    {statusTemplateOptions.map((opt, i) => (
                        <label key={i}>
                            <input
                                type="checkbox"
                                value={opt}
                                checked={selectedStatusTemplates.includes(opt)}
                                onChange={handleStatusTemplateCheckbox}
                            />
                            {opt}
                        </label>
                    ))}
                </div>
                <div className="selected-groups-list">
                    {selectedStatusTemplates.length === 0
                        ? <span className="empty">None selected</span>
                        : selectedStatusTemplates.map(val => (
                            <span key={val}>{val}</span>
                        ))
                    }
                </div>
            </div>

            {(showNewForm || showEditForm || showFilterPanel) && (
                <div
                    className="off-canvas-overlay"
                    onClick={() => {
                        setShowNewForm(false);
                        setShowEditForm(false);
                        setShowFilterPanel(false);
                    }}
                ></div>
            )}

            {showPopup && (
                <div className="popup-message">
                    {popupMessage}
                </div>
            )}
        </div>
    );
}
